"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractDataFromResponse = exports.createApolloClient = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
var client_1 = require("@apollo/client");
/* Because apollo SDK ignores BASIC credential (of API) stored in browser, we need to pass it.
 * So that implemented Cookie based BASIC credential store for dev environment.
 * Use following way to set BASIC credential to call API of dev environment:
 * - Do following in F12 console:
 *   - `Cookies.set('api-basic-auth-user', 'm3-nyc');`
 *   - `Cookies.set('api-basic-auth-password', '...');`
 */
try {
    window.Cookies = js_cookie_1.default; // Assign global object to allow use of debug console
}
catch (_a) { }
function createApolloClient(config) {
    var baseUrl = config.baseUrl, resolvers = config.resolvers, possibleTypes = config.possibleTypes;
    var authorization = config.authorization ? devApiAuthorizationHeader() : '';
    var cache = new client_1.InMemoryCache(possibleTypes ? { possibleTypes: possibleTypes } : {});
    var cachedData = window.__APOLLO_STATE__;
    cache.restore(cachedData);
    return new client_1.ApolloClient({
        uri: "".concat(baseUrl, "/graphql"),
        headers: {
            authorization: authorization,
        },
        cache: cache,
        credentials: 'include',
        resolvers: resolvers,
    });
}
exports.createApolloClient = createApolloClient;
var devApiAuthorizationHeader = function () {
    return "Basic ".concat(window.btoa("".concat(js_cookie_1.default.get('api-basic-auth-user'), ":").concat(js_cookie_1.default.get('api-basic-auth-password'))));
};
var extractDataFromResponse = function (result) {
    if (!result) {
        throw new Error('empty response.');
    }
    if (result.errors) {
        var messages = result.errors.map(function (e) { return e.message; });
        throw new Error("GraphqlErrors: ".concat(messages.join(',')));
    }
    if (typeof result.data === 'undefined' || result.data === null) {
        throw new Error('Undefined response data.');
    }
    return result.data;
};
exports.extractDataFromResponse = extractDataFromResponse;
//# sourceMappingURL=apollo-client.js.map